import { render, staticRenderFns } from "./PublicationStorageReportModal.vue?vue&type=template&id=778dd75c&"
import script from "./PublicationStorageReportModal.vue?vue&type=script&lang=js&"
export * from "./PublicationStorageReportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports